// Note that Google tag manager integrates with Didomi to automatically set consent for Analytics.
// updateGtagConsent() below is only used in the SourcePoint fallback mode (see boot/gdpr.ts), which
// has no such native integration.
import { hasVendorGrant } from './gdpr_consent'

declare function gtag(command: string, action: string, params?: Record<string, unknown>): void

export function gtagPush(eventData: Record<string, unknown>): void {
  if (!window.googleTagManager) {
    return
  }

  const ignoredEvents = ['player.videoCurrentTime']

  if (ignoredEvents.includes(eventData.event as string)) {
    return
  }

  if (eventData.env === 'development' || eventData.env === 'staging') {
    console.log('[Google Tag Manager] Tracking event', eventData)
  }

  window.dataLayer?.push(eventData)
}

export function updateGtagConsent(): void {
  const analyticsConsent = hasVendorGrant('Google Analytics') ? 'granted' : 'denied'

  gtag('consent', 'update', {
    analytics_storage: analyticsConsent,
  })
}
